<template>
  <div class="login-container">
    <div class="logo-box">
      <img src="@/assets/images/logo.png" class="logo-img" alt="">
      <div class="divider--vertical"></div>
      <span class="title"> 答题卡制作</span>
    </div>
    <div class="form-box">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-position="left">
        <div class="header">
          <div class="title">
            账号登录
          </div>
        </div>
        <el-form-item prop="userCode">
          <el-input
            ref="userCode"
            v-model="loginForm.userCode"
            placeholder="请输入用户名"
            name="userCode"
            type="text"
            prefix-icon="el-icon-user-solid"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            :key="passwordType"
            ref="userPwd"
            v-model="loginForm.userPwd"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            prefix-icon="el-icon-lock"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <!--      <el-form-item  class="login-button-item">-->
        <el-button class="login-button" :loading="loading" type="primary" round @click.native.prevent="handleLogin">登录</el-button>
        <!--      </el-form-item>-->
      </el-form>
    </div>
    <div class="bah">
      <div>Copyright © Septnet 2010-2020 All Rights Reserved. 皖ICP备12003204号-3 皖公网安备 34019002600301号</div>
    </div>
  </div>
</template>

<script>
  import $ from "jquery"
  import userApi from '../services/user'
  export default {
    name: 'Login',
    data() {
      const validateUserCode = (rule, value, callback) => {
        if (value && value.length !== 11) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value && value.length < 6) {
          callback(new Error('请输入至少6位数密码'))
        } else {
          callback()
        }
      }
      return {
        loginForm: {
          userCode: '',
          userPwd: ''
        },
        loginRules: {
          userCode: [{ required: true, trigger: 'blur', validator: validateUserCode }],
          userPwd: [{ required: true, trigger: 'blur', validator: validatePassword }]
        },
        loading: false,
        passwordType: 'password'
      }
    },
    methods: {
      handleLogin() {
        // 360浏览器下切换页面可能会出现输入框有值但是 this.loginForm 内没有值的情况
        if (!this.loginForm.userCode && $('input[name="userCode"]').val()) this.loginForm.userCode = $('input[name="userCode"]').val()
        if (!this.loginForm.userPwd && $('input[name="password"]').val()) this.loginForm.userPwd = $('input[name="password"]').val()
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.loginForm))
            userApi.Login(formData).then((res) => {
              this.$store.dispatch('user/setUserToken', res.data.tk)
              this.$router.push({ path:'/' })
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss" >

  $inputBg: #fff;
  $cursor: rgba(0, 0, 0, .65);

  @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
    .login-container .el-input input {
      color: $cursor;
    }
  }

  /* reset element-ui css */
  .login-container {

    .el-input {
      display: inline-block;
      height: 33px;
      /*width: 85%;*/

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        /*border-radius: 0px;*/
        background-color: #fff !important;
        /*padding: 12px 5px 12px 50px;*/
        padding-left: 50px;
        color: #333;
        height: 33px;
        caret-color: $cursor;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px $inputBg inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }
    .el-input__prefix{
      color: #409eff;
    }
    .el-form-item {
      border: 1px solid #d9d9d9;
      background: $inputBg;
      /*border-radius: 5px;*/
      color: #454545;
    }
  }
</style>

<style lang="scss" scoped>
  $svg_color: #454545;

  .login-container {
    height: 100%;
    width: 100%;
    background: url("../assets/images/login_new.png");
    background-repeat: no-repeat;
    background-size: 70% 100%;
    overflow: hidden;
    background-color: #fff;
    .bah{
      width: 70%;
      position: absolute;
      bottom: 20px;
      left: 0;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
    /*display: flex;*/
    /*align-items: center;*/
    .logo-box{
      margin-left: 40px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 280px;
      height: 100px;
      .logo-img{
        height: 50px;
        display: block;
      }
      .divider--vertical{
        height: 25px;
        border: 1px solid #fff;
      }
      .title{
        color: #fff;
        display: block;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;
        font-size: 22px;
      }
    }
    .form-box{
      height: 100%;
      width: 30%;
      display: flex;
      align-items: center;
      justify-content: center;
      float: right;
      .login-form {
        width: 90%;
        /*margin-right: 2%;*/

        /*margin-top: 120px;*/
        border-radius: 10px;
        /*overflow: hidden;*/
      }
    }


    .header {
      margin-bottom: 20px;
      .title {
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;
        font-size: 30px;
        color: rgba(0, 0, 0, .65);
        /*margin-bottom: 25px;*/
        text-align: left;
        font-weight: bolder;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 50px;
      }

      img {
        width: auto;
        height: 80px;
        display: block;
        margin: 0 auto;
      }
    }
    .login-button {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 280px;
      /*height: 35px;*/
      font-size: 14px;
      color: #fff;
      /*border-radius: 8px;*/
      /*background-color: #41b7fd;*/
      /*background-image: linear-gradient(to right, #18deff, #41b7fd);*/
    }

    .tips {
      margin-top: 10px;
      font-size: 14px;
      color: #bbb;
    }
  }
</style>
